module.exports = __webpack_public_path__ + "img/3.8ce7d9ac.jpg";